var React = require('react');

function Sun (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"2384.1","cy":"249.8","fill":"#e06f2f","r":"249.8"}));
}

Sun.defaultProps = {"enableBackground":"new 0 0 4871 4338.8","viewBox":"0 0 4871 4338.8"};

module.exports = Sun;

Sun.default = Sun;
